import { Observable, Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { NgZone } from "@angular/core";
import { runInNgZone } from "@app/core/utils/run-in-zone-helper";

interface BroadcastMessage {
  type: string;
  payload: boolean;
}

export class BroadcastService {
  private broadcastChannel: BroadcastChannel;
  private onMessage = new Subject<any>();

  constructor(
    broadcastChannelName: string,
    private ngZone: NgZone
  ) {
    this.broadcastChannel = new BroadcastChannel(broadcastChannelName);
    this.broadcastChannel.onmessage = (message) => this.onMessage.next(message.data);
  }

  publish(message: BroadcastMessage): void {
    this.broadcastChannel.postMessage(message);
  }

  messagesOfType(type: string): Observable<BroadcastMessage> {
    return this.onMessage.pipe(
      // It is important that we are running in the NgZone. This will make sure that Angular component changes are immediately visible in the browser when they are updated after receiving messages.
      runInNgZone(this.ngZone),
      filter((message) => message.type === type)
    );
  }
}
